import React from 'react';
import { IssuePerDayCount } from '../../models/issueItem';
import SortableTable, { ColumnDefinition } from '../common/SortableTable';

interface IssuePerDayTableProps {
  perDayCounts: IssuePerDayCount[];
}

// Define the type of data that SortableTable will receive
interface PerDayTableData {
    date: string;
    count: number;
}
  
const IssuePerDayTable: React.FC<IssuePerDayTableProps> = ({ perDayCounts }) => {
  const columns: ColumnDefinition<PerDayTableData>[] = [
    { key: 'date', label: 'Date', sortable: true },
    { key: 'count', label: 'Count', sortable: true },
  ];    

  const data = perDayCounts.map((item) => ({
    date: item.date,
    //    date: new Date(item.date).toLocaleDateString(), 
    count: item.count,
  }));

  return (
    <div className="w-full max-h-[600px] p-4 overflow-y-auto">
      <SortableTable data={data} columns={columns} rowIdKey={'date'}/>
    </div>
  );
};

export default IssuePerDayTable;
